// TODO: refactor? --> consider using zod/mini?

export interface ProjectStaffOptions extends ProjectStaffOptionsBase {
  readonly field: string;
  isVisible: boolean;
  isRequired: boolean;
  descriptionToken?: string | undefined;
}
export interface ProjectStaffOptionsBase {
  readonly propertyPath: string;
}
export interface ProjectStaffOptionsDto extends ProjectStaffOptionsBase {
  readonly fieldName: string;
  visible: boolean;
  required: boolean;
  description?: string | undefined;
}
export interface ProjectStaffFieldsBase {
  firstName: ProjectStaffOptionsDto;
  lastName: ProjectStaffOptionsDto;
  title: ProjectStaffOptionsDto;
  gender: ProjectStaffOptionsDto;
  birthPlace: ProjectStaffOptionsDto;
  nationality: ProjectStaffOptionsDto;
  userImage: ProjectStaffOptionsDto;
  email: ProjectStaffOptionsDto;
  phoneNumber: ProjectStaffOptionsDto;
  correspondenceLanguage: ProjectStaffOptionsDto;
  socialSecurityNumber: ProjectStaffOptionsDto;
  chSocialSecurityNumber: ProjectStaffOptionsDto;
  idDocument: ProjectStaffOptionsDto;
  idDocumentNumber: ProjectStaffOptionsDto;
  idDocumentIssueDate: ProjectStaffOptionsDto;
  idDocumentExpiryDate: ProjectStaffOptionsDto;
  residencePermit: ProjectStaffOptionsDto;
  residencePermitExpiryDate: ProjectStaffOptionsDto;
  chResidencePermit: ProjectStaffOptionsDto;
  chResidencePermitExpiryDate: ProjectStaffOptionsDto;
  position: ProjectStaffOptionsDto;
  supervisor: ProjectStaffOptionsDto;
  firstAider: ProjectStaffOptionsDto;
  companyParamedic: ProjectStaffOptionsDto;
  number: ProjectStaffOptionsDto;
}
export interface ProjectStaffFieldsDto extends ProjectStaffFieldsBase {
  ewr: ProjectStaffOptionsDto;
  birthday: ProjectStaffOptionsDto;
  insurance: ProjectStaffOptionsDto;
  insuranceCompany: ProjectStaffOptionsDto;
  insuranceNumber: ProjectStaffOptionsDto;
  insuranceExpiryDate: ProjectStaffOptionsDto;

}


type ProjectStaffFieldsFromBase = {
  [P in keyof ProjectStaffFieldsBase]: ProjectStaffOptions;
};

export interface ProjectStaffFields extends ProjectStaffFieldsFromBase {
  europeanEconomicArea: ProjectStaffOptions;
  dateOfBirth: ProjectStaffOptions;
  healthInsured: ProjectStaffOptions;
  healthInsuranceCompany: ProjectStaffOptions;
  healthInsuranceNr: ProjectStaffOptions;
  healthInsuranceExpiryDate: ProjectStaffOptions;
}

function parseToProjectStaffOptions (value: ProjectStaffOptionsDto): ProjectStaffOptions {
  return {
    propertyPath: value.propertyPath,
    descriptionToken: value.description,
    field: value.fieldName,
    isRequired: value.required,
    isVisible: value.visible
  };
}

function parseToProjectStaffOptionsDto (value: ProjectStaffOptions): ProjectStaffOptionsDto {
  return {
    propertyPath: value.propertyPath,
    description: value.descriptionToken,
    fieldName: value.field,
    required: value.isRequired,
    visible: value.isVisible
  };
}

export function parseToProjectStaffFields (value: ProjectStaffFieldsDto): ProjectStaffFields {
  return {
    number: parseToProjectStaffOptions(value.number),
    firstName: parseToProjectStaffOptions(value.firstName),
    lastName: parseToProjectStaffOptions(value.lastName),
    title: parseToProjectStaffOptions(value.title),
    gender: parseToProjectStaffOptions(value.gender),
    dateOfBirth: parseToProjectStaffOptions(value.birthday),
    birthPlace: parseToProjectStaffOptions(value.birthPlace),
    nationality: parseToProjectStaffOptions(value.nationality),
    userImage: parseToProjectStaffOptions(value.userImage),
    email: parseToProjectStaffOptions(value.email),
    phoneNumber: parseToProjectStaffOptions(value.phoneNumber),
    correspondenceLanguage: parseToProjectStaffOptions(value.correspondenceLanguage),
    socialSecurityNumber: parseToProjectStaffOptions(value.socialSecurityNumber),
    chSocialSecurityNumber: parseToProjectStaffOptions(value.chSocialSecurityNumber),
    idDocument: parseToProjectStaffOptions(value.idDocument),
    idDocumentNumber: parseToProjectStaffOptions(value.idDocumentNumber),
    idDocumentIssueDate: parseToProjectStaffOptions(value.idDocumentIssueDate),
    idDocumentExpiryDate: parseToProjectStaffOptions(value.idDocumentExpiryDate),
    healthInsured: parseToProjectStaffOptions(value.insurance),
    healthInsuranceCompany: parseToProjectStaffOptions(value.insuranceCompany),
    healthInsuranceNr: parseToProjectStaffOptions(value.insuranceNumber),
    healthInsuranceExpiryDate: parseToProjectStaffOptions(value.insuranceExpiryDate),
    residencePermit: parseToProjectStaffOptions(value.residencePermit),
    residencePermitExpiryDate: parseToProjectStaffOptions(value.residencePermitExpiryDate),
    chResidencePermit: parseToProjectStaffOptions(value.chResidencePermit),
    chResidencePermitExpiryDate: parseToProjectStaffOptions(value.chResidencePermitExpiryDate),
    position: parseToProjectStaffOptions(value.position),
    supervisor: parseToProjectStaffOptions(value.supervisor),
    firstAider: parseToProjectStaffOptions(value.firstAider),
    companyParamedic: parseToProjectStaffOptions(value.companyParamedic),
    europeanEconomicArea: parseToProjectStaffOptions(value.ewr)
  };
}
export function parseToProjectStaffFieldsDto (value: ProjectStaffFields): ProjectStaffFieldsDto {
  return {
    number: parseToProjectStaffOptionsDto(value.number),
    firstName: parseToProjectStaffOptionsDto(value.firstName),
    lastName: parseToProjectStaffOptionsDto(value.lastName),
    title: parseToProjectStaffOptionsDto(value.title),
    gender: parseToProjectStaffOptionsDto(value.gender),
    birthday: parseToProjectStaffOptionsDto(value.dateOfBirth),
    birthPlace: parseToProjectStaffOptionsDto(value.birthPlace),
    nationality: parseToProjectStaffOptionsDto(value.nationality),
    userImage: parseToProjectStaffOptionsDto(value.userImage),
    email: parseToProjectStaffOptionsDto(value.email),
    phoneNumber: parseToProjectStaffOptionsDto(value.phoneNumber),
    correspondenceLanguage: parseToProjectStaffOptionsDto(value.correspondenceLanguage),
    socialSecurityNumber: parseToProjectStaffOptionsDto(value.socialSecurityNumber),
    chSocialSecurityNumber: parseToProjectStaffOptionsDto(value.chSocialSecurityNumber),
    idDocument: parseToProjectStaffOptionsDto(value.idDocument),
    idDocumentNumber: parseToProjectStaffOptionsDto(value.idDocumentNumber),
    idDocumentIssueDate: parseToProjectStaffOptionsDto(value.idDocumentIssueDate),
    idDocumentExpiryDate: parseToProjectStaffOptionsDto(value.idDocumentExpiryDate),
    insurance: parseToProjectStaffOptionsDto(value.healthInsured),
    insuranceCompany: parseToProjectStaffOptionsDto(value.healthInsuranceCompany),
    insuranceNumber: parseToProjectStaffOptionsDto(value.healthInsuranceNr),
    insuranceExpiryDate: parseToProjectStaffOptionsDto(value.healthInsuranceExpiryDate),
    residencePermit: parseToProjectStaffOptionsDto(value.residencePermit),
    residencePermitExpiryDate: parseToProjectStaffOptionsDto(value.residencePermitExpiryDate),
    chResidencePermit: parseToProjectStaffOptionsDto(value.chResidencePermit),
    chResidencePermitExpiryDate: parseToProjectStaffOptionsDto(value.chResidencePermitExpiryDate),
    position: parseToProjectStaffOptionsDto(value.position),
    supervisor: parseToProjectStaffOptionsDto(value.supervisor),
    firstAider: parseToProjectStaffOptionsDto(value.firstAider),
    companyParamedic: parseToProjectStaffOptionsDto(value.companyParamedic),
    ewr: parseToProjectStaffOptionsDto(value.europeanEconomicArea)
  };
}
